export default class RentalPeriod {
  // eslint-disable-next-line max-params
  constructor(
    id,
    destination_id,
    inventory_unit_id,
    layout_position_id,
    order_id,
    all_day,
    position_x,
    position_y,
    starts_at,
    ends_at,
    actual_starts_at,
    actual_ends_at
  ) {
    this.id = id;
    this.destinationId = destination_id;
    this.inventoryUnitId = inventory_unit_id;
    this.layoutPositionId = layout_position_id;
    this.orderId = order_id;
    this.allDay = all_day;
    this.positionX = position_x;
    this.positionY = position_y;
    this.startsAt = starts_at;
    this.endsAt = ends_at;
    this.actualStartsAt = actual_starts_at;
    this.actualEndsAt = actual_ends_at;
  }

  static fromAttributes(
    {
      id,
      destination_id,
      inventory_unit_id,
      layout_position_id,
      order_id,
      all_day,
      position_x,
      position_y,
      starts_at,
      ends_at,
      actual_starts_at,
      actual_ends_at
    }
  ) {
    return new RentalPeriod(
      id,
      destination_id,
      inventory_unit_id,
      layout_position_id,
      order_id,
      all_day,
      position_x,
      position_y,
      starts_at,
      ends_at,
      actual_starts_at,
      actual_ends_at
    );
  }
}
